import { useMemo } from 'react';
import TimePicker from '@/app/KeywordTracker/components/common/TimePicker';
import { DEFAULT_LOCALE } from '@/locales/localeConfig';
import { useProject } from '../../context/ProjectContext';
import { getVisibilityRangeBounds } from '../../utils/visibility-range';

function toUnixSeconds(date: Date): number {
  return Math.floor(date.getTime() / 1000);
}

/** Calendar day (YYYY-MM-DD) an instant falls on in the project's display timezone (Tehran). */
function unixToIsoDate(unix: number): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: DEFAULT_LOCALE.timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(unix * 1000));
}

export function TrackerAiTimePicker() {
  const { visibilityRange, customFrom, customTo, setCustomDateRange } = useProject();

  const { initDay, lastDay } = useMemo(() => {
    const { start, end } = getVisibilityRangeBounds(
      visibilityRange,
      customFrom,
      customTo,
    );
    const now = new Date();
    const fallbackStart = new Date(now);
    fallbackStart.setUTCDate(fallbackStart.getUTCDate() - 29);

    return {
      initDay: toUnixSeconds(start ?? fallbackStart),
      lastDay: toUnixSeconds(end ?? now),
    };
  }, [visibilityRange, customFrom, customTo]);

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      <h6 className="text-700 mb-0 text-nowrap fs--1">بازه زمانی</h6>
      <div style={{ minWidth: '13rem' }}>
        <TimePicker
          key={`${visibilityRange}-${customFrom}-${customTo}`}
          initDay={initDay}
          lastDay={lastDay}
          onApply={(fromUnix, toUnix) => {
            if (fromUnix == null || toUnix == null) return;
            const from = unixToIsoDate(Math.min(fromUnix, toUnix));
            const to = unixToIsoDate(Math.max(fromUnix, toUnix));
            setCustomDateRange(from, to);
          }}
        />
      </div>
    </div>
  );
}
